import SideBar from "./SideBar";
import React from "react";
function Book() {
  return (
    <div className="">
      <section className="class_room_wrap">
        <div className="custom_container">
          <div className="row">
            <div className="col-xxl-3 col-xl-3 col-lg-12 col-md-12 px-0 left_side_bar  pb-0">
              <SideBar />
            </div>
            <div className="col-xxl-9 col-xl-9 col-lg-12  ">
              <div className="inner_header">
                <div className="row align-items-center">
                  <div className="col-xl-8 col-lg-12">
                    <div className="content_wrap">
                      <h5>
                        EXPLORATIONS: An Open... | <span>shook et al.</span>
                      </h5>
                      <h5>CHAPTER 1, SECTION 1</h5>{" "}
                    </div>
                  </div>
                  <div className="col-xl-4  col-lg-12">
                    <div className="right_content">
                      <h5>
                        <u>all activities</u> in <u> highlighted section</u>{" "}
                      </h5>{" "}
                    </div>
                    <hr />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-8 col-lg-12">
                  <div className="main_content">
                    <h4 className="sub_heading max_550">
                      Introduction to Biological Anthropology
                    </h4>
                    <p className="theme_para_se">
                      Katie Nelson, Ph.D., Inver Hills Community CollegeLara
                      Braff, Ph.D., Grossmont CollegeBeth Shook, Ph.D.,
                      California State University, ChicoKelsie Aguilera, M.A.,
                      Leeward Community College
                    </p>
                    <hr />
                    <h4 className="mini_heading">Learning Objectives</h4>
                    <ul className="list_style mb-25">
                      <li>
                        {" "}
                        Define anthropology and the main anthropological
                        approaches.
                      </li>
                      <li>
                        Describe the origins and early development of
                        anthropology.
                      </li>
                      <li>
                        Identify the four subdisciplines of anthropology and
                        specify the focus of each one.
                      </li>
                      <li>
                        Define biological anthropology, describe its key
                        questions, and identify major subfields.
                      </li>
                      <li>Explain key components of the scientific method.</li>
                      <li>
                        Differentiate between hypotheses, theories, and laws.
                      </li>
                      <li>Differentiate science from other ways of knowing.</li>
                    </ul>
                    <p className="theme_para_se">
                      The first time one of the authors [Katie Nelson] heard of
                      biological anthropology, she was a first-year college
                      student at Macalester College in Saint Paul, Minnesota,
                      taking her first-ever anthropology course. Before she
                      enrolled in the class she didn’t really know what
                      anthropology meant. She knew it had something to do with
                      people, but didn’t know how it all fit together. The
                      course description appealed to her, so she signed up. She
                      quickly learned that anthropology was the study of humans
                      and that it was an incredibly broad discipline that
                      included explorations of cultural diversity, human
                      origins, past human societies, and human languages, among
                      a great many other subjects. She had always been
                      interested in learning about people. She enjoyed observing
                      the different ways people interacted in public spaces,
                      like the mall or the zoo. She enjoyed learning Spanish in
                      high school and loved listening to how people who spoke
                      different languages produced different sounds. She was
                      curious about how people inherited unique characteristics
                      from their parents and was especially intrigued by
                      immigration and migration and what caused people to uproot
                      themselves and move to another part of the world. During
                      the second week of class she began to learn about
                      biological anthropology and some of the leading theories
                      for how and why ancient humans left Africa and migrated
                      throughout the world. As she sat in class, she vividly
                      remembers imagining a small group of ancient humans
                      walking barefoot together through the African savannah.
                      She imagined what they wore, what their language sounded
                      like, how they held hands, how they shared food, and so
                      on. She wondered why they were migrating and what they
                      would miss about their homeland. She was hooked on
                      anthropology!
                    </p>
                    <h4 className="mini_heading">After the introduction</h4>
                    <p className="theme_para_se">
                      {" "}
                      To reach your academic goals and pass your expectations,
                      finding and maintaining motivation and engagement in
                      school is an important first step to achievement and
                      success. This section can help give ideas on how to find
                      and maintain motivation to engage in the things you want
                      to do.
                    </p>
                    <div className="page_nation">
                      <h6>Dec ‘21</h6>
                      <ul>
                        <li>
                          <a href="">1</a>
                        </li>
                        <li>
                          <a href="">2</a>
                        </li>
                        <li>
                          <a href="">3</a>
                        </li>
                        <li>
                          <a href="">4</a>
                        </li>
                        <li>
                          <a href="">5</a>
                        </li>
                        <li>
                          <a href="">6</a>
                        </li>
                        <li>
                          <a href="">7</a>
                        </li>
                        <li>
                          <a href="">8</a>
                        </li>
                        <li>
                          <a href="">9</a>
                        </li>
                        <li>
                          <a href="" className="active">
                            10
                          </a>
                        </li>
                        <li>
                          <a href="">11</a>
                        </li>
                        <li>
                          <a href="">12</a>
                        </li>
                        <li>
                          <a href="">13</a>
                        </li>
                        <li>
                          <a href="" className="last-child">
                            <img
                              src="../assets/images/arrow_right_page.svg"
                              alt="arrow_right_page"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4  col-lg-12 left_side_bar right_side_bar edite_box_right pt-0">
                  <div className="box_detail edite_box">
                    <h5 className="mb-0">
                      free response | Discussion | 3 more{" "}
                    </h5>
                    <h3>
                      Definition of terms{" "}
                      <span>
                        <a href="">
                          <u>See versions</u>
                        </a>{" "}
                        <a href="">
                          <u>edit</u>
                        </a>
                      </span>
                    </h3>
                    <p className="text_grey  line_limt  ">
                      20 pts | 3 questions
                    </p>
                    <p className="fw_500 lh_16">
                      In Chapter 1 of Explorations, we learned the difference
                      between knowledge and beliefs. Before we begin, answer the
                      following questions in your own words and then compare
                      your definitions to
                    </p>
                  </div>
                  <div className="edit_option mb-12">
                    <h4>
                      What is knowledge? <span>free response</span>{" "}
                    </h4>
                  </div>
                  <div className="edit_option mb-12">
                    <h4>
                      What is a belief? <span>free response</span>{" "}
                    </h4>
                  </div>
                  <div className="edit_option mb-12">
                    <h4>
                      What is the difference
                      <br /> between these two concepts?
                      <span>free response</span>{" "}
                    </h4>
                  </div>
                  <hr className="my-4" />
                  <div className="box_detail edite_box">
                    <h5 className="mb-0">
                      free response | Discussion | 3 more{" "}
                    </h5>
                    <h3>
                      Definition of terms{" "}
                      <span>
                        <a href="">
                          <u>See versions</u>
                        </a>{" "}
                        <a href="">
                          <u>edit</u>
                        </a>
                      </span>
                    </h3>
                    <p className="text_grey  line_limt  ">
                      20 pts | 3 questions
                    </p>
                    <p className="fw_500 lh_16">
                      In Chapter 1 of Explorations, we learned the difference
                      between knowledge and beliefs. Before we begin, answer the
                      following questions in your own words and then compare
                      your definitions to
                    </p>
                  </div>

                  <div className="custom+checkbox">
                    <div className="input-wrapper">
                      <input
                        className="fancy-radio"
                        hidden
                        id="radio1"
                        name="radio-group"
                        type="radio"
                      />
                      <label className="fancy-radio-label" htmlFor="radio1">
                        <span className="fancy-label--text">
                          Aliquam tincidunt mauris eu risus
                        </span>
                        <span className="fancy-radiobutton">
                          <span className="radiobutton-dot"></span>
                        </span>
                      </label>
                    </div>
                    <div className="input-wrapper">
                      <input
                        className="fancy-radio"
                        hidden
                        id="radio2"
                        name="radio-group"
                        type="radio"
                      />
                      <label className="fancy-radio-label" htmlFor="radio2">
                        <span className="fancy-label--text">
                          Praesent placerat risus quis eros
                        </span>
                        <span className="fancy-radiobutton">
                          <span className="radiobutton-dot"></span>
                        </span>
                      </label>
                    </div>
                    <div className="input-wrapper">
                      <input
                        className="fancy-radio"
                        hidden
                        id="radio3"
                        name="radio-group"
                        type="radio"
                      />
                      <label className="fancy-radio-label" htmlFor="radio3">
                        <span className="fancy-label--text">
                          Cras ornare tristique elit
                        </span>
                        <span className="fancy-radiobutton">
                          <span className="radiobutton-dot"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                  <a href="" className="next_btn">
                    next section
                    <img
                      src="../assets/images/arrow-right.png"
                      className="ml-2"
                      alt=""
                    />{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Book;
